import { PaperClipOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import React, { CSSProperties, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Attachments from '../../components/Attachments/Attachments';
import { RootState } from '../../store';
import { ItemType } from '../../types';

type ProjectAttachmentsProps = {
    item: ItemType;
    expanded?: boolean;
    style?: CSSProperties;
};

const StyledCollapse = styled(Collapse)`
    border-radius: 8px;
    overflow: hidden;

    .ant-collapse-header {
        padding: 12px 16px !important;
        font-weight: 500;
        background-color: #fafafa;
        display: flex;
        align-items: center;
    }

    .ant-collapse-content {
        padding: 12px 16px !important;
    }
`;

export const ProjectAttachments: React.FC<ProjectAttachmentsProps> = ({ item, style, expanded }) => {
    const isDragging = useSelector<RootState, boolean>((state) => state.gantDraggable.isDragging);

    const collapseItems = useMemo(
        () => [
            {
                key: 0,
                label: (
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <PaperClipOutlined style={{ marginRight: 8 }} />
                        Attachments
                    </span>
                ),
                children: (
                    <div style={{ margin: '12px 0' }}>
                        {!isDragging && <Attachments model_id={item.id} model_type={'ScheduleItem'} isAccess={{}} />}
                    </div>
                ),
            },
        ],
        [item],
    );

    return <StyledCollapse defaultActiveKey={expanded ? 0 : undefined} style={style} items={collapseItems} />;
};
